import { Link } from "react-router-dom";
import { useState } from 'react'
import { useParams } from "react-router-dom";
import Footer from './Footer'
import './Login.css'
import { useTranslation } from "react-i18next";

const ResetPasswordSubmit = () => {
  const { t } = useTranslation();

  const { shop } = useParams();
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')

  const token = window.location.search.split('=')[1];

  const passwordResetSubmit = (e) => {
    e.preventDefault();

    if (password !== passwordConfirm) {
        alert(t('reser_password_submit.error'));
        return;
    }

    fetch(process.env.REACT_APP_API_URL + '/sanctum/csrf-cookie', {
        method: 'GET',
        credentials: "include",
        cache: 'no-store',
    }).then((response) => {
        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) {
            xsrfToken = xsrfToken.split('=')[1]
        } else {
            alert(t('common.error'));
            return;
        }
        fetch(process.env.REACT_APP_API_URL + '/api/password/reset/submit', {
            method: 'POST',
            cache: 'no-store',
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                'Accept': 'application/json',
            },
            credentials: "include",
            body: JSON.stringify({
                token: token,
                password: password,
            }),
        }).then((response) => {
            if (response.status === 200) {
                return response.json();
            } else {
                let message = response.json().message;
                throw new Error(message);
            }
        })
        .then((data) => {
            if (data.message) {
                alert(data.message);
            }
            
            window.location.href = '/' + shop + '/login';
        }).catch((error) => {
            alert(error);
        });
    }).catch((error) => {
        alert(error);
    });
}

  return (
    // ページを左右に分ける
    <div className="flex flex-row login-content">
        {/* 左側 */}
        <div className="w-1/2 login-content-left">
            <h1 className="text-center login-content-title">ORIPAL</h1>
            <div className="login-form-description">{t('reser_password_submit.description')}</div>
            <form className="login-form">
                <label className="login-content-label">{t('reser_password_submit.password')}</label>
                <input className="login-content-input-text" type="password" placeholder={t('reser_password_submit.password')} value={password} onChange={(e) => setPassword(e.target.value)} />
                <label className="login-content-label">{t('reser_password_submit.confirm')}</label>
                <input className="login-content-input-text" type="password" placeholder={t('reser_password_submit.confirm')} value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} />
                <button className="login-button" onClick={passwordResetSubmit}>{t('reser_password_submit.submit')}</button>
            </form>
            <Link to={"/" + shop + "/login"} className="reset-password-link">{t('reser_password_submit.back')}</Link>
            <Footer />
        </div>
        {/* 右側 */}
        <div className="w-1/2 login-content-right">
        </div>
    </div>
  )
}

export default ResetPasswordSubmit